import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  APIProvider,
  Map,
  Marker,
  InfoWindow,
  useMap,
  useMarkerRef,
} from "@vis.gl/react-google-maps";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

const apiKey = "AIzaSyCD7OEdGUC1V__0-mBJIoYifI5UtEILYbg";
const DEFAULT_CENTER = { lat: 9.314623823, lng: 2.31184834 };
const menukey = "facility";

const labelCellStyle = {
  fontWeight: "bold",
  borderRight: "1px solid antiquewhite",
};

const isValidCoord = (lat, lng) => {
  const parsedLat = Number(lat);
  const parsedLng = Number(lng);
  return (
    !Number.isNaN(parsedLat) &&
    !Number.isNaN(parsedLng) &&
    (parsedLat !== 0 || parsedLng !== 0)
  );
};

const FacilityInfoContent = ({ formData }) => {
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");

  const rows = [
    {
      label: DispensingLanguage[lan][menukey]["Facility Name"],
      value: formData?.FacilityName,
    },
    {
      label: DispensingLanguage[lan][menukey]["Facility Address"],
      value: formData?.FacilityAddress,
    },
    {
      label: DispensingLanguage[lan][menukey]["Facility Phone"],
      value: formData?.FacilityPhone,
    },
  ];

  return (
    <TableContainer>
      <Table aria-label="facility info table">
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.label}>
              <TableCell style={labelCellStyle}>{row.label}</TableCell>
              <TableCell>{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const MapPanToMarker = ({ position }) => {
  const map = useMap();

  useEffect(() => {
    if (map && position) {
      map.panTo(position);
    }
  }, [map, position?.lat, position?.lng]);

  return null;
};

const GoogleMap = ({ updateLatLang, addProductForm, latlng, formData }) => {
  const [markerRef, marker] = useMarkerRef();
  const [showingInfoWindow, setShowingInfoWindow] = useState(false);

  const shouldShowMarker = useMemo(() => {
    if (addProductForm) {
      return isValidCoord(latlng?.[0], latlng?.[1]);
    }
    return isValidCoord(formData?.Latitude, formData?.Longitude);
  }, [
    addProductForm,
    latlng,
    formData?.Latitude,
    formData?.Longitude,
  ]);

  const markerPosition = useMemo(() => {
    if (addProductForm && isValidCoord(latlng?.[0], latlng?.[1])) {
      return { lat: Number(latlng[0]), lng: Number(latlng[1]) };
    }
    if (isValidCoord(formData?.Latitude, formData?.Longitude)) {
      return {
        lat: Number(formData.Latitude),
        lng: Number(formData.Longitude),
      };
    }
    return null;
  }, [
    addProductForm,
    latlng,
    formData?.Latitude,
    formData?.Longitude,
  ]);

  const handleDragEnd = useCallback(
    (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      if (formData) {
        formData.location = `${lat},${lng}`;
        if (!addProductForm) {
          formData.Latitude = lat;
          formData.Longitude = lng;
        }
      }

      updateLatLang?.(lat, lng);
    },
    [addProductForm, formData, updateLatLang]
  );

  const handleMarkerClick = useCallback(() => {
    setShowingInfoWindow(true);
  }, []);

  const handleInfoWindowClose = useCallback(() => {
    setShowingInfoWindow(false);
  }, []);

  return (
    <APIProvider apiKey={apiKey}>
      <Map
        style={{ width: "100%", height: "100%", minHeight: "500px" }}
        defaultCenter={DEFAULT_CENTER}
        defaultZoom={10}
        gestureHandling="greedy"
        draggable
        zoomControl
        mapTypeControl={false}
        streetViewControl={false}
        fullscreenControl={false}
      >
        {shouldShowMarker && markerPosition && (
          <>
            <MapPanToMarker position={markerPosition} />
            <Marker
              ref={markerRef}
              position={markerPosition}
              draggable
              onDragEnd={handleDragEnd}
              onClick={handleMarkerClick}
              icon={{
                url: require("assets/img/marker_icon.png"),
              }}
            />
            {showingInfoWindow && (
              <InfoWindow
                anchor={marker}
                position={markerPosition}
                onClose={handleInfoWindowClose}
              >
                <FacilityInfoContent formData={formData} />
              </InfoWindow>
            )}
          </>
        )}
      </Map>
    </APIProvider>
  );
};

export default GoogleMap;
